/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SearchCommandsInt(parameters) {
  const response = await $.soap({
    body: {
      SearchCommands: {
        $xmlns: 'http://dla.mil/ems/bpm/command',
        CommandID: parameters.commandID,
        DODAAC: parameters.dodac,
        CommandName: parameters.commandName,
        ServiceBranchID: parameters.serviceBranchID,
        RegionID: parameters.regionID
      }
    },
    blueprintArrays: ['SearchCommandsResponse.row'],
    blueprint: {
      totalCount: '$..TotalCount',
      commands: [
        'SearchCommandsResponse.row',
        {
          id: '$.ID',
          dodac: '$.DODAC',
          name: '$.CommandName',
          serviceBranchID: '$.ServiceBranchID',
          serviceBranchName: '$.ServiceBranchName',
          regionID: '$.RegionID',
          regionName: '$.RegionName'
        }
      ]
    }
  });
  cleanUpResponse(response);
  if (!response.totalCount) {
    response.totalCount = 0;
  }
  return response;
}
